import React from 'react'
import { Card, TextField, CardContent, Button, FormControl, Grid, MenuItem } from '@mui/material';

import { LinearLoading } from 'common'

export const FormExpenses = ({ useFetchInit }) => {

    const {
        //------------- Generales
        //------------- globalStates
        // globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    // const { showForm } = globalStates

    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { FormScreen } = Forms
    const { formState, onInputChange } = FormScreen
    
    // ------------------------------------------------ FetchData
    const { fetchSpecificExpense } = FetchData
    const { loadingFetchSpecificExpense } = fetchSpecificExpense

    // ------------------------------------------------ Actions
    const { onSubmitForm, handleClickHideForm } = Actions

    return (
        <div className='content'>
            <Card style={{zIndex:'1'}}>
                <CardContent>
                    <div className='h4 mt-1 mb-1'>
                        {formState.idexpense > 0
                            ? 'Actualizar Registro'
                            : 'Crear Registro'}
                    </div>
                    <div className="border-bottom border-dark"></div>
                    {loadingFetchSpecificExpense && ( <LinearLoading /> )}

                    <div className="pt-3"></div>
                    <p className='text-danger'>* campos obligatorios</p>
                    <div className="pt-2"></div>

                    <form onSubmit={onSubmitForm}>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="type_expense"
                                        name="type_expense"
                                        placeholder="Selecciona una opción"
                                        label="Tipo"
                                        value={formState.type_expense}
                                        onChange={onInputChange}
                                        select
                                        size="small"
                                        lable="Selecciona una opción"
                                        variant="standard"
                                        // hiddenLabel
                                        InputProps={{ readOnly: false }}
                                    >
                                        <MenuItem value=''>-- Selecciona una opción --</MenuItem>
                                        <MenuItem value='ABOGACIA & NOTARIADO'>ABOGACIA & NOTARIADO</MenuItem>
                                        <MenuItem value='PREDIO JUDICIAL'>PREDIO JUDICIAL</MenuItem>
                                        <MenuItem value='GENERAL'>GENERAL</MenuItem>
                                    </TextField>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="descripcion"
                                        name="descripcion"
                                        value={formState.descripcion}
                                        onChange={onInputChange}
                                        label='Descripción'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        // hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <div className="pt-4"></div>
                        <Grid container>
                            <Grid item>
                                <div className='update ml-auto mr-auto'>
                                    <Button
                                        style={{background: "#4b4b4c"}}
                                        variant="contained"
                                        type='submit'
                                    >
                                        <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                                    </Button>
                                    &nbsp; &nbsp;
                                    <Button
                                        style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                        type='button'
                                        variant="contained"
                                        onClick={handleClickHideForm}
                                    >
                                        <i className="fa-regular fa-circle-left"></i> &nbsp; Cancelar
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        </div>
    )
}
